import initMobileNav from './modules/mobile-nav';
import initSliders from './modules/sliders';
import initVideoPlayer from './modules/video-player';
import initSpeakerTabs from './modules/speaker-tabs';
import initFadeIn from './modules/fade-in';
import initCountUp from './modules/count-up';
import initPostSlider from './modules/post-slider';
import initLoginMenu from './modules/login-menu';
import initSearch from './modules/search';
import initAlertBanner from './modules/alert-banner';
import initHorizontalScrollers from './modules/horizontal-scroller';
import initNavSubmenuEdge from './modules/nav-submenu-edge';
import initAccessibility from './modules/accessibility';
import initRecentNews from '../blocks-acf/recent-news/recent-news';
import initRestaurantsScroller from '../blocks-acf/restaurants-scroller/restaurants-scroller';
import initArtExhibitsGrid from '../blocks-acf/art-exhibits-grid/art-exhibits-grid';
import initArtLightbox from './modules/art-lightbox';

initMobileNav();
initSliders();
initVideoPlayer();
initSpeakerTabs();
initFadeIn();
initCountUp();
initPostSlider();
initLoginMenu();
initSearch();
initAlertBanner();
initHorizontalScrollers();
initNavSubmenuEdge();
initAccessibility();
initRecentNews();
initRestaurantsScroller();
initArtExhibitsGrid();
initArtLightbox();
